import * as React from 'react';
import renderIcon from 'helpers/renderIcon';
import * as c from 'models/constants';

interface IProps {
	itemType: string;
}

const PlaceholderItemCard: React.FC<IProps> = (props) => {
	if (props.itemType === c.NODE_TYPE_OFFICE_ITEM_CARD) {
		return (
			<div className={'officeItemCard card dark skeleton'}>
				<div className="row no-gutters">
					<div className="col-sm-7 officeInfo">
						<div className="imageAndNameContainer d-flex flex-row">
							<div className="imageHolder">{renderIcon('symbol1', 60, 60)}</div>
							<div className="nameAndAddressContainer d-flex flex-column">
								<h3 className="skeletonAnimation" />
								<div className="locationContainer d-flex">
									<p className="p14 skeletonAnimation" />
								</div>
							</div>
						</div>
						<div className="details-row">
							<div className="skeletonAnimation"></div>
							<div className="skeletonAnimation"></div>
							<div className="skeletonAnimation"></div>
						</div>
					</div>
					<figure className="col-sm-5 shopPicture skeletonAnimation">
						<div className="imageHolder">{renderIcon('symbol1', 60, 60)}</div>
					</figure>
				</div>
			</div>
		);
	}

	return (
		<div className={`col-6 col-sm-6 col-md-4 col-xl-3 col-xlg-3 col-fhd-3 placeholder placeholder-${props.itemType}`}>
			<div>
				<i className="icon">{renderIcon('symbol1')}</i>
			</div>
			<div>
				<span />
				<span />
				<span />
				<span />
				<span />
			</div>
		</div>
	);
};

export { PlaceholderItemCard };
